import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AthleteLayout from "../common/AthleteLayout";
import { AthleteHeader } from "../common/AthleteHeader";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import API_URL from "../../api/API";

export const AthletePurchasedSpeedProducts = () => {
  const { athlete } = useAthleteAuthContext();
  const navigate = useNavigate();
  const location = useLocation();

  const [templates, setTemplates] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [selectedDate, setSelectedDate] = useState(new Date());

  // ============================
  // Fetch Purchased Speed Products
  // ============================
  const fetchTemplatesData = async () => {
    try {
      setIsLoading(true);

      const response = await fetch(
        API_URL.FRONTEND_ATHLETE_PURCHASED_SPEED_PRODUCTS + athlete.id,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${athlete.token}`,
          },
        },
      );

      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData?.error || "Failed to fetch purchased products");
        return;
      }

      const json = await response.json();
      console.log("Purchased Products:", json.data);

      setTemplates(json.data || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplatesData();
  }, [athlete.id, athlete.token]);

  const changeDate = (days) => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + days);
      return newDate;
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <AthleteLayout>
      <div className="h-full flex flex-col bg-white">
        <div className="mt-1 border-t border-black/30"></div>
        {/* DATE HEADER */}
        {/* <div className="w-full max-w-screen-xl mx-auto px-5">
          <div className="pt-5 pb-3 mt-3 flex flex-row justify-center items-center gap-10">
            <ArrowL onClick={() => changeDate(-1)} />
            <p className="text-black text-xl">{formatDate(selectedDate)}</p>
            <ArrowG onClick={() => changeDate(1)} />
          </div>
        </div> */}

        {/* MAIN CONTENT */}
        <div className="flex-1 overflow-y-auto">
          <div className="w-full max-w-2xl mx-auto">
            <div className="py-3">
              <div className="flex justify-between gap-8 mb-4 px-5">
                <button className="text-black border-b-2 border-yellow-600 text-base pb-2 font-bold">
                  Speed Products
                </button>
              </div>

              {isLoading ? (
                <p className="text-black text-center">Loading...</p>
              ) : error ? (
                <div className="bg-red-100 text-red-500 p-3 rounded mb-4">
                  {error}
                </div>
              ) : (
                <div className="space-y-4 px-5">
                  {templates.map((item) => (
                    <button
                      key={item._id}
                      onClick={() =>
                        navigate(
                          `/athlete/speed-product/warmup-routine-phases/${item._id}`,
                          {
                            state: {
                              product_basic: item, // optional but helpful
                            },
                          },
                        )
                      }
                      className="w-full p-[14px] text-black text-sm font-medium border border-black/90 bg-transparent rounded-xl hover:bg-grayish/10 transition text-start"
                    >
                      <p className="text-base xs:text-lg font-medium">{item.title}</p>
                      <p className="text-sm text-grayish">
                        Purchased on:{" "}
                        {new Date(
                          item.purchase_details.purchased_on,
                        ).toLocaleDateString()}
                      </p>
                    </button>
                  ))}

                  {templates.length === 0 && (
                    <p className="text-center text-grayish">
                      No purchased products found.
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </AthleteLayout>
  );
};

// ARROWS
const ArrowG = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      className="hover:opacity-50 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L0.999999 1"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ArrowL = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      className="hover:opacity-50 rotate-180 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L0.999999 1"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
